import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useCallback, useContext, useMemo } from 'react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { Link } from '../../link';
import { ShowtimePickerContextInstance } from '../types/context';
const b = bemClassBuilder('v-showtime-picker-film-action-link');
export const ShowtimePickerFilmActionLink = observer(() => {
    const { film } = useFilmContext();
    const { displayText, events, config } = useContext(ShowtimePickerContextInstance);
    const { onFilmActionLinkClicked } = events;
    const { urlFactory } = config.filmActionLink;
    if (!film)
        throw new Error('Cannot render the ShowtimePickerFilmActionLink without a film.');
    const filmUrl = useMemo(() => urlFactory === null || urlFactory === void 0 ? void 0 : urlFactory(film), [urlFactory, film]);
    const handleActionLinkClicked = useCallback(() => {
        onFilmActionLinkClicked === null || onFilmActionLinkClicked === void 0 ? void 0 : onFilmActionLinkClicked(film);
    }, [onFilmActionLinkClicked, film]);
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(Link, Object.assign({ className: b.element('link'), href: filmUrl, onClick: onFilmActionLinkClicked && handleActionLinkClicked }, { children: displayText.filmActionLinkText })) })));
});
ShowtimePickerFilmActionLink.displayName = 'ShowtimePickerFilmActionLink';
